import { Component, Input} from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ValidationService } from '../../services/validation.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'control-messages',
    template: `  
    <div  class="invalid-feedback" *ngIf="errorMessage !== null" >{{errorMessage|translate| replace : 'MINLENGTH' : length}}</div>

    `,
   
    styles: [`
        .is-invalid {
            border: 1px solid #D8000C;
        }
        .invalid-feedback {
            display: inline;
            color: #D8000C;
            margin-top: 5px;
              }
    `] 
})
export class ControlMessages {
 
    @Input() control: FormControl;
    @Input() isShow: boolean = false;
    length = '1';
    constructor(private translate: TranslateService) { }


    public get errorMessage() {
        if (this.control)
            for (let propertyName in this.control.errors) {
                if (this.control.errors.hasOwnProperty(propertyName) && (this.control.touched || this.isShow)) {
            
                    var t= ValidationService.getValidatorErrorMessage(propertyName, this.control.errors[propertyName]);
                    this.length = this.control.errors[propertyName].requiredLength + '';
            
                    return t;
                }
            }
        return null;
    }

    public static clearForm( form: FormGroup ) {
          Object.keys(form.controls).forEach(key => {
          let item = form.get(key);
          if (item.validator != null)
            item.setValue("");
          item.markAsUntouched();
        });
      }
}